import { Size, Coords } from 'src/types';

/**
 * Renderer configuration
 */
export interface RendererConfig {
    showGrid?: boolean;
    backgroundColor?: string;
    enableDebugTools?: boolean;
}

/**
 * Canvas viewport information
 */
export interface ViewportInfo {
    size: Size;
    center: Coords;
    zoom: number;
}

/**
 * Render layer ordering (z-index management)
 */
export enum RenderLayer {
    BACKGROUND = 0,
    GRID = 1,
    RECTANGLES = 2,
    CURSOR = 3,
    CONNECTORS = 4,
    TEXT_BOXES = 5,
    CONNECTOR_LABELS = 6,
    DEBUG = 7,
    INTERACTIONS = 8,
    NODES = 9,
    TRANSFORM_CONTROLS = 10
}

/**
 * Scene element types that can be rendered
 */
export type SceneElementType =
    | 'node'
    | 'connector'
    | 'rectangle'
    | 'textbox'
    | 'label';

/**
 * Render context passed to rendering functions
 */
export interface RenderContext {
    viewport: ViewportInfo;
    zoom: number;
    scroll: { position: Coords; offset: Coords };
}